// Language Configuration Data
import { Language, LanguageCode } from '../types/language';
import { RegionCode } from '../types/region';

// Supported Languages
export const LANGUAGES: Record<LanguageCode, Language> = {
  en: {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇬🇧',
    rtl: false,
    locale: 'en-US'
  },
  hi: {
    code: 'hi',
    name: 'Hindi',
    nativeName: 'हिन्दी',
    flag: '🇮🇳',
    rtl: false,
    locale: 'hi-IN'
  },
  es: {
    code: 'es',
    name: 'Spanish',
    nativeName: 'Español',
    flag: '🇪🇸',
    rtl: false,
    locale: 'es-ES'
  },
  ar: {
    code: 'ar',
    name: 'Arabic',
    nativeName: 'العربية',
    flag: '🇸🇦',
    rtl: true,
    locale: 'ar-SA'
  },
};

// Default language for each region
export const REGION_DEFAULT_LANGUAGES: Record<RegionCode, LanguageCode> = {
  IN: 'en',      // India - English (Hindi available as option)
  US: 'en',      // United States - English
  GB: 'en',      // United Kingdom - English
  EU: 'en',      // Europe - English (other languages available)
  AU: 'en',      // Australia - English
  CA: 'en',      // Canada - English
  SG: 'en',      // Singapore - English
  AE: 'en',      // UAE - English (Arabic offered)
  MY: 'en',      // Malaysia - English
  GLOBAL: 'en'   // Global - English
};

// Popular languages for each region
export const REGION_POPULAR_LANGUAGES: Record<RegionCode, LanguageCode[]> = {
  IN: ['en', 'hi'],
  US: ['en', 'es'],
  GB: ['en'],
  EU: ['en', 'es'],
  AU: ['en'],
  CA: ['en'],
  SG: ['en'],
  AE: ['en', 'ar'],
  MY: ['en'],
  GLOBAL: ['en', 'es', 'ar', 'hi']
};
